import React, { Component } from 'react'
import { checkTranslation, imageAddress } from '../../../../utils/useful';
import CircularProgress from "../../../useful/CircularProgress";
import MessageStatusView from './MessageStatusView';


class MessageVideoBox extends Component {
    render() {
        let data = this.props.data

        let address = ''
        if (data?.video) {
            address = imageAddress(data.video)
        } else if (data.tempFile) {

            if (this.state?.address) {
                address = this.state.address
            } else {
                address = URL.createObjectURL(data.tempFile)
                this.setState({ address })
            }

        }

        return (
            <div style={{ width: 250 }} className={'w-100 d-flex flex-column ' + (this.props.isOtherRef ? 'justify-content-start align-items-start' : 'justify-content-end align-items-end')}>
                <div style={{ width: 250, background: "#E9ECF6", borderRadius: 15, borderBottomRightRadius: 0, }}>
                    <div style={{ width: 250, overflow: "hidden", position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>

                        {(data.tempFile) && (
                            <div className='flexcc ' style={{ padding: 2, border: '0px solid #eee', boxShadow: '0px 0px 30px #10101040', backgroundColor: '#ffffffcc', borderRadius: 80, position: "absolute", zIndex: 1, }}>
                                <CircularProgress size={34} strokeWidth={3} progress={data.precentage} />
                            </div>
                        )}

                        <video width="250" height="auto" className='br-10' controls={data.tempFile ? false : true}>
                            <source src={address} type="video/mp4" />
                        </video>
                    </div>

                    {data.text && (
                        <p style={{ color: "#000", fontSize: 13, textAlign: "left", padding: 10 }}>{checkTranslation(data.text)}</p>
                    )}
                </div>
                <div className={"w-100 d-flex mt-1 " + (this.props.isOtherRef ? 'justify-content-start align-items-start' : 'justify-content-end align-items-end')}>
                    <div className="flexc">
                        <p className='mrd-2' style={{ color: "gray", fontSize: 10 }}>{checkTranslation(this.props.time)}</p>
                        {!this.props.isOtherRef && (
                            <MessageStatusView status={data.status} colors={this.props.colors} />
                        )}
                    </div>
                </div>
            </div>

        )
    }
}

export default MessageVideoBox;